import { z } from "zod/v4"

export const roleSchema = z.union([z.literal("admin"), z.literal("member")])

export type TRole = z.infer<typeof roleSchema>
